<template>
    <div class="view-body">
        <div class="view-body-item" v-for="(item, index) in list" :key="index">
            <div class="body-item-hd">
                <span>{{ item.shrMc }}</span>
                <span>{{ item.phone }}</span>
            </div>
            <div class="body-item-bd">{{ item.shengMc + item.chengshiMc + item.quxianMc + item.detaileAddress }}</div>
            <div class="body-item-ft">
                <div class="item-ft-left" @click="setDefaultRow(item)">
                    <img src="~img/common/yixuan.png" v-if="item.ifDefAddress == 1" alt="">
                    <img src="~img/common/weixuan.png" v-if="item.ifDefAddress == -1" alt="">
                    <span>默认地址</span>
                </div>
                <div class="item-ft-right">
                    <div class="ft-right-item" @click="$router.push(`/addressDetail?id=${item.id}`)">
                        <img src="~img/common/bianji.png" alt="">
                        <span>编辑</span>
                    </div>
                    <div class="ft-right-item" @click="deleteRow(item.id)">
                        <img src="~img/common/shanchu.png" alt="">
                        <span>删除</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        list: Array
    },
    methods: {
        setDefaultRow(row) {
            this.$parent.setDefaultAddress({
                id: row.id,
                ifDefAddress: row.ifDefAddress === 1 ? -1 : 1
            }).then((res) => {
                this.$parent.getAddressList();
                this.$toast(res.msg);
            }).catch((res) => {
                this.$toast(res.error);
            });
        },
        deleteRow(value) {
            this.$dialog.confirm({
                title: '提示',
                message: '您确定要删除该地址吗？'
            }).then(() => {
                this.$parent.deleteAddress({ id: value }).then((res) => {
                    this.$parent.getAddressList();
                    this.$toast(res.msg);
                }).catch((res) => {
                    this.$toast(res.error);
                });
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.view-body {
    flex: 1;
    overflow-y: auto;
    padding: 11px 12px;
    text-align: left;

    .view-body-item {
        padding: 0 16px;
        border-radius: 5px;
        margin-bottom: 11px;
        background-color: #FFFFFF;

        .body-item-hd {
            display: flex;
            padding: 14px 0;
            color: #000000;
            font-size: 15px;
            justify-content: space-between;
        }
        .body-item-bd {
            color: #8A8A8A;
            font-size: 12px;
            padding-bottom: 15px;
            border-bottom: 1px solid #E5E5E5; /* no */
        }
        .body-item-ft {
            display: flex;
            padding: 17px 0;
            justify-content: space-between;

            .item-ft-left {
                line-height: 22px;

                img {
                    width: 22px;
                    vertical-align: middle;
                }
                span {
                    font-size: 15px;
                    margin-left: 12px;
                    color: #333333;
                    vertical-align: middle;
                }
            }
            .item-ft-right {
                line-height: 22px;

                .ft-right-item {
                    margin-right: 33px;
                    float: left;

                    img {
                        width: 16px;
                        vertical-align: middle;
                    }
                    span {
                        font-size: 15px;
                        margin-left: 6px;
                        color: #333333;
                        vertical-align: middle;
                    }
                }
                .ft-right-item:last-child {
                    margin-right: 0;
                }
            }
        }
    }
}
</style>